var MqList = {
	"--mobile-xs": "(min-width: 320px)",
	"--mobile-s": "(min-width: 360px)",
	"--mobile-m": "(min-width: 375px)",
	"--mobile-l": "(min-width: 412px)",
	"--mobile": "(max-width: 599px)",
	"--tablet-s": "(min-width: 600px)",
	"--tablet-m": "(min-width: 768px)",
	"--tablet": "(min-width: 600px) and (max-width: 1023px)",
	"--desktop-s": "(min-width: 1024px)",
	"--desktop-m": "(min-width: 1280px)",
	"--desktop-l": "(min-width: 1440px)",
	"--desktop-xl": "(min-width: 1920px)",
	"--desktop": "(min-width: 1024px)"
};

// TODO: перенести в alfalab/utils
var pool = {};
var refCounters = {};
/**
 * Возвращает MediaQueryList для заданного media-выражения.
 *
 * @param queryProp media выражение или кастомный запрос из `mq.json`, например `--mobile`.
 */
function getMatchMedia(queryProp) {
    var query = MqList[queryProp] || queryProp;
    if (pool[query]) {
        refCounters[query] += 1;
    }
    else {
        pool[query] = window.matchMedia(query);
        refCounters[query] = 1;
    }
    return pool[query];
}
/**
 * Удаляет MediaQueryList.
 *
 * @param queryProp media выражение или кастомный запрос из `mq.json`, например `--mobile`.
 */
function releaseMatchMedia(queryProp) {
    var query = MqList[queryProp] || queryProp;
    refCounters[query] -= 1;
    if (pool[query] && refCounters[query] === 0) {
        delete pool[query];
        delete refCounters[query];
    }
}
/**
 * Возвращает `true`, если есть поддержка `Pointer Events`
 */
function isPointerEventsSupported() {
    return 'PointerEvent' in window || 'msPointerEnabled' in window.navigator;
}
/**
 * Возвращает `true`, если есть поддержка `Touch Events`
 */
function isTouchSupported() {
    return ('ontouchstart' in window ||
        window.navigator.maxTouchPoints > 0 ||
        window.navigator.msMaxTouchPoints > 0);
}

export { getMatchMedia, isPointerEventsSupported, isTouchSupported, releaseMatchMedia };
